import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-part-requests',
  templateUrl: './part-requests.component.html',
  styleUrls: ['./part-requests.component.scss', '../../product-dashboard/sell-item/select-item/select-item.component.scss'],
})
export class PartRequestsComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
